export default "__VITE_ASSET__DneEUiFe__"